<script>
import { mapState } from 'vuex';
import Popup from '../../components/mineTable/popup.vue';

export default {
    name: "order",
    data() {
        return {
            list: [],
            totalPrice: '0.00',
            isShowAddress: false,
            // 选中的地址索引
            selectedAddressIndex: null,
            // 选择的地址索引
            chooseAddressIndex: null,
        };
    },
    computed: {
        ...mapState(['shoppingData', 'shoppingTotalPrice', 'addressList']),
        detailPath() {
            return (type) => {
                switch (type) {
                    case 1:
                    case '1':
                        return '/shop/detail?id=';
                        break;
                    case 2:
                    case '2':
                        return '/gallery/works/detail?id=';
                        break;
                    default:
                        return '/shop/detail?id=';
                        break;
                }
            }
        },
    },
    components: {
        Popup
    },
    mounted() {
        // 获取地址列表
        this.$store.dispatch('getAddressList');
        if (this.$route.query.id) { 
            // 如果是立即购买，则获取商品详情
            this.getDetail();
        } else { 
            // 否则是购物车购买
            this.$store.dispatch('getShopCart');
        }
    },
    destroyed() {},
    watch: {
        addressList(newVal) { 
            // 设置默认选中地址
            newVal.forEach((v, i) => { 
                if (v.is_default == 1) { 
                    this.selectedAddressIndex = i;
                    this.chooseAddressIndex = i;
                }
            });
        },
        shoppingData: {
            handler(newVal) {
                if (!this.$route.query.id) { 
                    this.list = newVal;
                }
            },
            immediate: true,
        },
        shoppingTotalPrice: {
            handler(newVal) {
                if (!this.$route.query.id) { 
                    this.totalPrice = newVal;
                }
            },
            immediate: true,
        },
    },
    methods: {
        // 确定选中地址
        confirmChooseAddress() {
            this.selectedAddressIndex = this.chooseAddressIndex;
            this.isShowAddress = false;
        },
        // 取消选择地址
        cancelChooseAddress() {
            this.chooseAddressIndex = this.selectedAddressIndex;
            this.isShowAddress = false;
        },
        // 立即购买时，获取商品详情
        getDetail() { 
            let apiPath = '';
            switch (this.$route.query.type) {
                case '1':
                    apiPath = 'getShopDetail';
                    break;
                case '2':
                    apiPath = 'getGalleryWorksDetail';
                    break;
                default:
                    apiPath = 'getShopDetail';
                    break;
            }
            this.$store.dispatch(apiPath, {
                id: this.$route.query.id
            }).then((result) => {
                if (result.code == 100) {
                    // 计算总价
                    let total_price = (parseFloat(result.data.price) * (this.$route.query.count || 1)).toFixed(2);
                    this.totalPrice = total_price;
                    this.list = [
                        {
                            ...result.data,
                            count: this.$route.query.count || 1,
                            total_price,
                            goods_id: result.data.id,
                            type: this.$route.query.type || 1, // 1=商城商品购买 2=画廊商品购买
                        }
                    ];
                }
            }).catch((err) => {
                this.$showToast({ text: err.message || '获取商品详情失败' });
            });
        },
        // 下单
        placeOrder() { 
            // 地址未选择
            if (this.selectedAddressIndex === null) {
                this.$showToast({ text: '请选择收货地址' });
                return;
            }
            this.$showLoading();
            // 参数
            let params = {
                address_id: this.addressList[this.selectedAddressIndex].id,
            };
            // 如果是立即购买
            if (this.$route.query.id) { 
                params.type = this.$route.query.type || 1; // 	1=商城商品购买 2=画廊商品购买
                params.id = this.$route.query.id;
                params.count = this.$route.query.count || 1;
            }
            // 购物车购买
            // 只需要传address_id
            this.$store.dispatch('createShopOrder', params).then((result) => {
                this.$hideLoading();
                if (result.code == 100) {
                    this.$showToast({ text: '下单成功' });
                    // 跳转到支付页面
                    this.$router.push(`/shopping/pay?code=${result.data.order_code}`);
                } else if (result.code == 90) {
                    this.$showToast({ text: '登录凭证已失效' });
                    this.toLogin();
                } else {
                    this.$showToast({ text: result.msg || '下单失败' });
                }
            }).catch((err) => {
                this.$hideLoading();
                this.$showToast({ text: err.message || '下单失败' });
            });
        },
        // 跳转登录
        toLogin() { 
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            })
        },
    },
};
</script>

<template>
    <div class="order">
        <div class="list">
            <div class="item" v-for="(item, index) in list" :key="index">
                <div class="wrapper flex">
                    <router-link :to="`${detailPath(item.type)}${item.goods_id}`">
                        <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                    </router-link>
                    <div class="content flex flex_column justify_between">
                        <div class="info">
                            <p class="name"><router-link :to="`${detailPath(item.type)}${item.goods_id}`">{{ item.name }}</router-link></p>
                            <p class="price">RMB {{ item.price }}</p>
                            <div class="count">x{{ item.count }}</div>
                        </div>
                        <div class="bottom flex justify_end align_center only_pc">
                            <p class="price">实际付款 RMB {{ item.total_price }}</p>
                        </div>
                    </div>
                </div>
                <div class="bottom flex justify_end align_center only_mobile">
                    <p class="price">实际付款 RMB {{ item.total_price }}</p>
                </div>
            </div>
        </div>
        <div class="shopping_price flex justify_end">
            <div class="content">
                <!-- <div class="row price_wrap flex justify_between">
                    <p class="name">小计：</p>
                    <p class="price">RMB </p>
                </div>
                <div class="row price_wrap flex justify_between">
                    <p class="name">运费：</p>
                    <p class="price">RMB </p>
                </div> -->
                <div class="row price_wrap flex justify_between">
                    <p class="name">总计：</p>
                    <p class="price">RMB {{ totalPrice }}</p>
                </div>
            </div>
        </div>
        <div class="address_wrap">
            <p class="choose">
                <!-- <p>选择收货地址</p> -->
                <a href="javascript:;" @click="isShowAddress = true">更改收货地址</a>
                <router-link to="/mine/address">新增收货地址</router-link>
            </p>
            <template v-if="selectedAddressIndex !== null">
                <div class="flex"><p class="name">收货人</p>： {{ addressList[selectedAddressIndex].name }}</div>
                <div class="flex"><p class="name">联络电话</p>： {{ addressList[selectedAddressIndex].phone }}</div>
                <div class="flex"><p class="name">运送地址</p>： {{ addressList[selectedAddressIndex].area }} {{ addressList[selectedAddressIndex].address }}</div>
            </template>
            <template v-else>
                <p>请选择收货地址</p>
            </template>
        </div>
        <!-- 收货地址弹窗 -->
        <Popup :show="isShowAddress" title="选择地址" :isShowClose="true" @close="isShowAddress = false">
            <div class="address_list">
                <div class="item" v-for="(item, index) in addressList" :key="index" @click="chooseAddressIndex = index">
                    <div class="text">
                        <p>{{ item.name }}</p>
                        <p>{{ item.phone }}</p>
                        <p>{{ item.area }} {{ item.address }}</p>
                    </div>
                    <div class="checkbox" :class="{ active: chooseAddressIndex === index}"></div>
                </div>
            </div>
            <div class="btn_group flex justify_end">
                <div class="btn big" @click="cancelChooseAddress">取消</div>
                <div class="btn big" @click="confirmChooseAddress">完成</div>
            </div>
        </Popup>
        <div class="shopping_price flex justify_end">
            <div class="content">
                <div class="btn layout_flex_center" @click="placeOrder">继续结账</div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.order{
    .address_wrap{
        border-top: 1px solid #999;
        border-bottom: 1px solid #999;
        padding: .3rem 0;
        font-size: .18rem;
        display: flex;
        flex-direction: column;
        gap: .1rem;
        margin-bottom: .3rem;
        @media screen and (max-width: 750px) {
            border-top: none;
            font-size: .28rem;
        }
        .choose{
            font-weight: bold;
            font-size: .16rem;
            margin-bottom: .1rem;
            display: flex;
            gap: .2rem;
            justify-content: flex-end;
            @media screen and (max-width: 750px) {
                font-size: .28rem;
            }
        }
        .name{
            width: 4em;
            text-align-last: justify;
        }
    }
    .address_list{
        max-height: 4rem;
        overflow: hidden;
        overflow-y: auto;
        margin-bottom: .2rem;
        padding-right: .1rem;
        .item{
            padding: .1rem .2rem;
            border-radius: .1rem;
            font-size: .14rem;
            line-height: 1.5;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            @media screen and (max-width: 750px) {
                font-size: .22rem;
            }
            &:hover{
                background: #f0f0f0;
            }
            .checkbox{
                width: .2rem;
                height: .2rem;
                border: 1px solid var(--font_color);
                border-radius: 50%;
                @media screen and (max-width: 750px) {
                    width: .3rem;
                    height: .3rem;
                }
                &.active{
                    background: var(--font_color);
                    &::after{
                        content: "";
                        display: block;
                        width: 30%;
                        height: 60%;
                        border-right: 2px solid #fff;
                        border-bottom: 2px solid #fff;
                        position: relative;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -60%) rotate(45deg);
                    }
                }
            }
        }
    }
}
</style>